import {
  DoubleRightOutlined,
  FireFilled,
  FireOutlined,
  HeartFilled,
  HeartOutlined,
} from "@ant-design/icons";
import { Button, Rate, Card, Typography, Space, Tag } from "antd";
import EmptyImage from "assets/images/png/empty-image.png";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const { Text, Title } = Typography;

let search_params = "";

export default function CaddyCard({
  data,
  index,
  dateSearch,
  golfCourseSearch,
  teeOffTimeSearch,
  modePreferenceSearch,
  onClickAddFavorite,
  onClickRemoveFavorite,
  isfav,
}) {
  const [imageUrl, setImageUrl] = useState(null);
  // const [searchParams, setSearchPararms] = useState("");

  const navigate = useNavigate();

  const handleCheckImage = async (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  };

  useEffect(() => {
    const validateImage = async () => {
      const isValid = await handleCheckImage(data.profileUrl);
      setImageUrl(isValid ? data.profileUrl : EmptyImage);
    };

    validateImage();
  }, []);

  useEffect(() => {
    search_params = "";

    if (dateSearch) search_params = `?date=${dateSearch}`;
    if (teeOffTimeSearch)
      search_params = dateSearch
        ? `${search_params}${
            teeOffTimeSearch
              ? `&time=${dayjs(teeOffTimeSearch).format("HH:mm")}`
              : search_params
          }`
        : teeOffTimeSearch
        ? `?time=${dayjs(teeOffTimeSearch).format("HH:mm")}`
        : search_params;
    if (golfCourseSearch)
      search_params = search_params
        ? `${search_params}&golf_course=${golfCourseSearch}`
        : `?golf_course=${golfCourseSearch}`;
    if (modePreferenceSearch)
      search_params = search_params
        ? `${search_params}&modePreference=${modePreferenceSearch}`
        : `?modePreference=${modePreferenceSearch}`;

    // setSearchPararms(search_params);
  }, [dateSearch, teeOffTimeSearch, golfCourseSearch, modePreferenceSearch]);

  return (
    <div className="caddy-card-container" style={{ position: "relative" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 5,
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        {data.isHighlight && (
          <div
            style={{
              position: "absolute",
              left: 8,
              top: 8,
              zIndex: 99,
              background: "rgb(255 82 82)",
              borderRadius: 10,
              padding: 7,
              color: "white",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
          >
            <FireFilled size="large" />
            <b>HIGHLIGHT</b>
          </div>
        )}
        {data.isNewCaddy && !data.isHighlight && (
          <div
            style={{
              position: "absolute",
              left: 8,
              top: 8,
              zIndex: 99,
              background: "#90c7c5",
              borderRadius: 10,
              padding: 7,
              color: "white",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
          >
            <DoubleRightOutlined
              style={{ transform: "rotateZ(-90deg)" }}
              size="large"
            />
            <b>NEW</b>
          </div>
        )}

        {data?.profileUrl && imageUrl && (
          <div
            style={{
              height: 200,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              backgroundImage: `url(${imageUrl})`,
              backgroundPosition: "center center",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        )}
        <Card
          bodyStyle={{
            padding: "10px",
            position: "relative",
            height: "180px",
            display: "flex",
            flexDirection: "column",
          }}
          variant="borderless"
          style={{
            borderRadius: "0 0 20px 20px",
          }}
          actions={[
            <div style={{ padding: "0 8px" }}>
              <Button
                type="primary"
                size="large"
                block
                onClick={() =>
                  navigate(
                    `/book_caddy/${data.id}${
                      search_params ? search_params : ""
                    }`
                  )
                }
                style={{
                  borderRadius: "12px",
                  fontWeight: "600",
                  height: "32px",
                }}
              >
                ดูโปรไฟล์
              </Button>
            </div>,
          ]}
        >
          {/* Heart Icon */}
          <div style={{ position: "absolute", top: 20, right: 20, zIndex: 10 }}>
            {isfav ? (
              <HeartFilled
                onClick={() => onClickRemoveFavorite(data.id)}
                style={{
                  fontSize: 24,
                  cursor: "pointer",
                  color: "#ff4d4f",
                  filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.15))",
                }}
              />
            ) : (
              <HeartOutlined
                onClick={() => onClickAddFavorite(data.id)}
                style={{
                  fontSize: 24,
                  cursor: "pointer",
                  color: "#8c8c8c",
                  filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.15))",
                }}
              />
            )}
          </div>

          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                paddingRight: 40,
              }}
            >
              <Title
                level={4}
                style={{
                  margin: 0,
                  fontSize: 16,
                  lineHeight: "1.4",
                  color: "#262626",
                  fontWeight: "600",
                  marginBottom: "6px",
                  wordBreak: "break-word",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {data.display_name}
              </Title>

              <Text
                type="secondary"
                style={{
                  fontSize: 11,
                  display: "block",
                  lineHeight: "1.3",
                }}
              >
                หมายเลขแคดดี้ : {data.caddy_number}
              </Text>
            </div>

            <div
              style={{
                height: "80px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <Tag
                color="blue"
                style={{
                  fontSize: 12,
                  height: "60px",
                  padding: "4px 8px",
                  borderRadius: 8,
                  border: "none",
                  margin: 0,
                  width: "100%",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  lineHeight: "1.3",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  textAlign: "center",
                }}
              >
                {data.golf_course_name}
              </Tag>
            </div>

            <div
              style={{
                height: "30px",
                display: "flex",
                alignItems: "center",
                paddingRight: 40,
              }}
            >
              <Title
                level={3}
                style={{
                  margin: 0,
                  color: "#eb2f96",
                  fontSize: 18,
                  fontWeight: "700",
                  lineHeight: "1.2",
                }}
              >
                ทิป {new Intl.NumberFormat().format(data.price)} บาท
              </Title>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
